import { IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonLabel, IonRow, IonThumbnail, IonToolbar } from '@ionic/react';
import { useEffect, useState } from 'react';

import Copyright from '../../components/copyright/Copyright';
import { RouteNames } from '../../models/routes.model';
import { IonPageWrapper } from './AboutPage.styles';

interface IComponentProps {}

const AboutPage: React.FC<IComponentProps> = () => {
  const [versionString, setVersionString] = useState('');

  const getVersion = () => {
    setVersionString(process.env.REACT_APP_VERSION!);
  };

  useEffect(() => {
    getVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleViewPrivacyPolicyClick = () => {
    window.open('https://auto-it.com/web-app-privacy-policy', '_blank');
  };

  return (
    <IonPageWrapper>
      <IonHeader color="lightest">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref={RouteNames.dashboard} />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonRow className="app-title ion-text-center">
          <IonThumbnail className="logo">
            <img src="assets/icon/icon.png" alt="Tech Mobile Icon" />
          </IonThumbnail>
          <IonLabel> Tech Mobile</IonLabel>
        </IonRow>
        <IonRow className="app-item heading">
          <IonLabel color="white">technician mobile clocking</IonLabel>
        </IonRow>
        <IonRow className="app-item item flexed col">
          <span className="title">version</span>
          <span className="highlight">{versionString}</span>
        </IonRow>
        <IonRow className="app-item item">
          <IonButton size="small" expand="block" fill="outline" onClick={() => handleViewPrivacyPolicyClick()}>
            View Privacy Policy
          </IonButton>
        </IonRow>
        <Copyright />
      </IonContent>
    </IonPageWrapper>
  );
};

export default AboutPage;
